import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../contexts/AppContext";
import { useNavigate } from "react-router-dom";
import { UrlContext } from "../contexts/UrlContext";

export default function ApplicationsInfo() {
  const { allRequests } = useContext(AppContext);
  const [pending, setPending] = useState([]);
  const [completed, setCompleted] = useState([]);
  const [failed, setFailed] = useState([]);
  const [show, setShow] = useState("");
  const [percentagesString, setPercentagesString] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({});
  const navigate = useNavigate();
  const { API_URL, URI } = useContext(UrlContext);

  useEffect(() => {
    if (allRequests.length === 0) {
      navigate("/app/Usersapplications");
    } else {
      updateLists();
    }
  }, [allRequests]);

  const updateLists = () => {
    const pend = allRequests.filter((item) => item.status === "pending");
    const comp = allRequests.filter((item) => item.status === "completed");
    const fail = allRequests.filter((item) => item.status === "failed");
    const total = allRequests.length;
    const pendingPercent =
      total > 0 ? Math.round((pend.length / total) * 100) : 0;
    const completedPercent =
      total > 0 ? Math.round((comp.length / total) * 100) : 0;
    const failedPercent =
      total > 0 ? Math.round((fail.length / total) * 100) : 0;

    setPending(pend);
    setCompleted(comp);
    setFailed(fail);
    setPercentagesString(
      `${pendingPercent}%,${completedPercent}%,${failedPercent}%`
    );
  };
  const deleteRequest = async (id) => {
    fetch(`${API_URL}delete-user-application`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == "success") {
          setFailed((prevState) => prevState.filter((item) => item.id != id));
        }
      });
  };

  const updateRequest = async (form) => {
    fetch(`${API_URL}update-user-application`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ form }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == "success") {
          setPending([...pending, failed.filter((item) => item.id == form.id)]);
          setFailed((prevState) =>
            prevState.filter((item) => item.id != form.id)
          );
          window.dispatchEvent(
            new CustomEvent("eph-trigger-applications-scrape")
          );
        }
      });
  };

  const handleDelete = async (id) => {
    await deleteRequest(id);
    updateLists();
  };

  const handleEdit = (item) => {
    setEditingId(item.id);
    setEditForm(item);
  };

  const handleUpdate = async () => {
    await updateRequest(editForm);
    setEditingId(null);
    updateLists();
  };

  const handleChange = (e) => {
    setEditForm({ ...editForm, [e.target.name]: e.target.value });
  };

  return (
    <div className="requests-info-container">
      <i
        onClick={() => navigate("/app/Usersapplications")}
        className="fa fa-arrow-circle-o-left"
        style={{ fontSize: "2rem", alignSelf: "start", marginLeft: "30px" }}
      ></i>
      <div className="requests-porcentage">
        <div style={{ display: "flex", width: "100%", height: "40px" }}>
          <span
            style={{
              height: "100%",
              width: `${
                percentagesString.split(",")[0] === "0%"
                  ? "1%"
                  : percentagesString.split(",")[0]
              }`,
              backgroundColor: "rgba(38, 32, 207, 0.757)",
            }}
            onClick={() => setShow("pending")}
          >
            {pending.length}
          </span>
          <span
            style={{
              height: "100%",
              width: `${percentagesString.split(",")[1]}`,
              backgroundColor: "green",
            }}
            onClick={() => setShow("completed")}
          >
            {completed.length}
          </span>
          <span
            style={{
              height: "100%",
              width: `${percentagesString.split(",")[2]}`,
              backgroundColor: "red",
            }}
            onClick={() => setShow("failed")}
          >
            {failed.length}
          </span>
        </div>
      </div>
      <span className="mt-5">{show ? show.toUpperCase() : null}</span>
      <div className="request-info-details">
        {show === "failed" &&
          failed.map((item) => (
            <div
              className="request-info-details-item"
              key={item.id}
              onClick={() => handleEdit(item)}
            >
              {editingId === item.id ? (
                <>
                  <input
                    name="name"
                    value={editForm.name}
                    onChange={handleChange}
                  />
                  <input
                    name="email"
                    value={editForm.email}
                    onChange={handleChange}
                  />
                  <input
                    name="linkedinURL"
                    value={editForm.linkedinURL}
                    onChange={handleChange}
                  />
                  <input
                    name="phone"
                    value={editForm.phone}
                    onChange={handleChange}
                  />
                  <button onClick={handleUpdate}>Update</button>
                </>
              ) : (
                <>
                  <span>Name: {item.name}</span>
                  <span>Email: {item.email}</span>
                  <span>Linkedin: {item.linkedinURL}</span>
                  <span>Phone: {item.phone}</span>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDelete(item.id);
                    }}
                  >
                    Delete
                  </button>
                </>
              )}
            </div>
          ))}
        {show === "pending" &&
          pending.map((item) => (
            <div className="request-info-details-item" key={item.id}>
              <span>Name: {item.name}</span>
              <span>Email: {item.email}</span>
              <span>Linkedin: {item.linkedinURL}</span>
              <span>Phone: {item.phone}</span>
            </div>
          ))}
        {show === "completed" &&
          completed.map((item) => (
            <div className="request-info-details-item" key={item.id}>
              <span>Name: {item.name}</span>
              <span>Email: {item.email}</span>
              <span>Linkedin: {item.linkedinURL}</span>
              <span>Phone: {item.phone}</span>
            </div>
          ))}
      </div>
    </div>
  );
}
